// extracted by mini-css-extract-plugin
export default {"aboutBar":"aboutbar_aboutBar__2basy"};